export default "__VITE_ASSET__BY4BeG_B__"